import { EulaFooter } from '@user/EulaFooter';

import { SidebarContainer } from './SidebarContainer';
import { SidebarContext, useSidebarValues } from './SidebarContext';

type Props = {
  children: React.ReactNode;
};

export const WithSidebar: React.FC<Props> = ({ children }: Props) => {
  const {
    isSidebarVisible,
    sidebarWidth,
    isSidebarOpenButtonVisible,
    isSidebarSettled,
    toggleSidebar,
    startResizingSidebarWidth,
    resizingSidebarWidth,
    endResizingSidebarWidth,
  } = useSidebarValues();

  // 利用可否の判定が確定するまでは transition を無効化する。確定時の幅切り替えが
  // アニメーションせず一発で最終幅に飛ぶことで、初回ロード時の幅アニメーションを防ぎ、
  // キャンバス側（ResizeObserver 実測）も即座に最終幅を得られる。
  const widthTransition = isSidebarSettled ? 'width 0.3s' : '';

  return (
    <SidebarContext.Provider
      value={{ isSidebarVisible, isSidebarOpenButtonVisible, sidebarWidth, isSidebarSettled, toggleSidebar }}
    >
      <div className="flex flex-row">
        <div
          style={{ width: isSidebarVisible ? sidebarWidth : '0px', transition: widthTransition }}
          className="relative"
        >
          {isSidebarVisible && <SidebarContainer handleSidebarOpen={toggleSidebar} />}
          <div
            className="absolute right-0 top-0 h-screen w-1 border-r-2 border-gray-300 hover:cursor-col-resize hover:border-gray-500"
            onPointerDown={startResizingSidebarWidth}
            onPointerMove={resizingSidebarWidth}
            onPointerUp={endResizingSidebarWidth}
          />
        </div>

        <div
          style={{
            width: `${isSidebarVisible ? `calc(100vw - ${sidebarWidth}px)` : '100vw'}`,
            transition: widthTransition,
          }}
        >
          {children}
        </div>
      </div>
      <EulaFooter />
    </SidebarContext.Provider>
  );
};
